import { render, staticRenderFns } from "./BuyBoxUpcomingNew.vue?vue&type=template&id=1f08e92c&scoped=true"
import script from "./BuyBoxUpcomingNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxUpcomingNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxUpcomingNew.vue?vue&type=style&index=0&id=1f08e92c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f08e92c",
  null
  
)

export default component.exports